import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    flexWrap: "nowrap",
  },
  button: {
    background: "#658D1B",
    border: 0,
    borderRadius: 1,
    color: "white",
    marginLeft: 10,
    marginRight: 10,
    alignItems: "center",
    justifyContent: "center",
    height: 40,
    width: "80%",
  },
  smButton: {
    background: "#658D1B",
    border: 0,
    borderRadius: 1,
    color: "white",
    marginLeft: 3,
    marginRight: 10,
    alignItems: "center",
    justifyContent: "center",
    height: 38,
    width: "100%",
  },
  buttonBox: {
    display: "flex",
    width: "100%",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "flex-end",
    marginTop: 15,
  },
  smButtonBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    marginTop: 15,
    width: "100%",
  },
  ocBox: {
    display: "flex",
    marginRight: 10,
    minWidth: 350,
    alignItems: "flex-end",
    justifyContent: "flex-start",
    width: "100%",
  },
  filterBox: {
    width: "95%",
    alignItems: "flex-end",
    flexDirection: "row",
    flexWrap: "nowrap",
  },
  branchFilter: {
    maxWidth: 400,
    width: '90%',
    flex:1,
  },
  assignFilter: {
    minWidth: 200,
    width: "100%"
  },
  filterGrid: {
    minWidth: 240
  },
  filter: {
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    marginTop: 15,
    marginRight: 10,
    width: "100%",
  },
  farmFilter: {
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "flex-end",
    maxWidth: 450,
    width: "100%",
  },
  searchIcon: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  },
  placeholder: {
    marginTop: 2,
    marginLeft: 10,
  },
}));

export default useStyles;
